// 自定义事件触发
function customEventTrigger(event, eventName, text, description) {
    if (typeof gtag !== 'function' || typeof fbq !== 'function') return;

    if (event.target.tagName === 'A') {
        event.preventDefault();
        const href = event.target.href;
        setTimeout(() => {
            // 当前页面打开（不新开页签）
            if (event.target.target === '_blank') {
                window.open(href)
            }else{
                window.location.href = href;
            }
        }, 200);
    }
    const now = new Date().toLocaleString();
    gtag('event', eventName, {
        event_description: description,
        page_url: window.location.href,
        time: now,
        goc_text: text,
        Remark: {
            page_url: '页面URL',
            time: '事件发生时间',
            goc_text: '点击文本',
        },
    });

    fbq('trackCustom', eventName, {
        event_description: description,
        page_url: window.location.href,
        time: now,
        goc_text: text,
        Remark: {
            page_url: '页面URL',
            time: '事件发生时间',
            goc_text: '点击文本',
        },
    });
    
};

// 跳转追踪
function jumpTracking(event) {
    if (typeof gtag !== 'function' || typeof fbq !== 'function') return;

    const now = new Date().toLocaleString();
    const href = event.target.closest('a').href;
    event.preventDefault();
    gtag('event', 'jumpTracking', {
        event_description: '从当前页面跳转到哪里',
        current_url: window.location.href,
        button_text: event.target.innerText,
        target_url: href,
        time: now,
        Remark: {
            current_url: '当前页面URL',
            button_text: '按钮文本',
            target_url: '跳转URL',
            time: '事件发生时间',
        },
    });

    fbq('trackCustom', 'jumpTracking', {
        event_description: '从当前页面跳转到哪里',
        current_url: window.location.href,
        button_text: event.target.innerText,
        target_url: href,
        time: now,
        Remark: {
            current_url: '当前页面URL',
            button_text: '按钮文本',
            target_url: '跳转URL',
            time: '事件发生时间',
        },
    });

        setTimeout(() => {
            // 当前页面打开（不新开页签）
            if (event.target.target === '_blank') {
                window.open(href)
            }else{
                window.location.href = href;
            }
        }, 200);
};

// 购买页跳转追踪
function buyPageJumpTracking(event, text) {
    if (typeof gtag !== 'function' || typeof fbq !== 'function') return;

    const now = new Date().toLocaleString();
    const href = event.target.closest('a').href;
    event.preventDefault();
    gtag('event', 'custom_cart', {
        event_description: '从那个页面跳转到购买页',
        current_url: window.location.href,
        button_text: event.target.innerText,
        target_url: href,
        time: now, 
        goc_text: text,
        Remark: {
            current_url: '当前页面URL',
            button_text: '按钮文本',
            target_url: '跳转URL',
            time: '事件发生时间',
        },
    });

    fbq('trackCustom', 'custom_cart', {
        event_description: '从那个页面跳转到购买页',
        current_url: window.location.href,
        button_text: event.target.innerText,
        target_url: href,
        time: now,
        goc_text: text,
        Remark: {
            current_url: '当前页面URL',
            button_text: '按钮文本',
            target_url: '跳转URL',
            time: '事件发生时间',
        },
    });

    if (!href) return;

        setTimeout(() => {
            // 当前页面打开（不新开页签）
            if (event.target.target === '_blank') {
                window.open(href)
            }else{
                window.location.href = href;
            }
        }, 200);
};

// 点击了chckout按钮
function checkoutButtonClick(text) {
    if (typeof gtag !== 'function' || typeof fbq !== 'function') return;

    const now = new Date().toLocaleString();
    gtag('event', 'custom_checkout', {
        event_description: '点击了chckout按钮',
        page_url: window.location.href,
        time: now,
        text: text,
        Remark: {
            page_url: '页面URL',
            time: '事件发生时间',
            text: '按钮文本',
        },
    });

    fbq('trackCustom', 'custom_checkout', {
        event_description: '点击了chckout按钮',
        page_url: window.location.href,
        time: now,
        text: text,
        Remark: {
            page_url: '页面URL',
            time: '事件发生时间',
            text: '按钮文本',
        },
    });
};

// 选择配置追踪
function selectTrimCard(element) {
    if (typeof gtag !== 'function' || typeof fbq !== 'function') return;

    const now = new Date().toLocaleString();
    let title = element.querySelector('.select-trim-card-title>span').textContent.replace(':', '');
    let price = element.querySelector('.select-trim-card-title>span:nth-child(2)').textContent;
    gtag('event', 'selectTrimCard', {
        event_description: '选择了那个配置',
        page_url: window.location.href,
        trim_title: title,
        trim_price: price,
        time: now,
        Remark: {
            page_url: '页面URL',
            trim_title: '配置标题',
            trim_price: '配置价格',
            time: '事件发生时间',
        },
    });

    fbq('trackCustom', 'selectTrimCard', {
        event_description: '选择了那个配置',
        page_url: window.location.href,
        trim_title: title,
        trim_price: price,
        time: now,
        Remark: {
            page_url: '页面URL',
            trim_title: '配置标题',
            trim_price: '配置价格',
            time: '事件发生时间',
        },
    });
};

// 展开/收起配置详情追踪
function openTrimCardDetail(element, isOpen) {
    if (typeof gtag !== 'function' || typeof fbq !== 'function') return;

    const now = new Date().toLocaleString();
    let title = element.querySelector('.select-trim-card-title>span').textContent.replace(':', '');
    gtag('event', 'openTrimCardDetail', {
        event_description: '展开/收起配置详情',
        page_url: window.location.href,
        trim_title: title,
        trim_is_open: !isOpen ? 'open' : 'close',
        time: now,
        Remark: {
            page_url: '页面URL',
            trim_title: '配置标题',
            trim_is_open: '配置展开状态',
            time: '事件发生时间',
        },
    });

    fbq('trackCustom', 'openTrimCardDetail', {
        event_description: '展开/收起配置详情',
        page_url: window.location.href,
        trim_title: title,
        trim_is_open: !isOpen ? 'open' : 'close',
        time: now,
        Remark: {
            page_url: '页面URL',
            trim_title: '配置标题',
            trim_is_open: '配置展开状态',
            time: '事件发生时间',
        },
    });
};

// 输入年份追踪
function inputYear(element) {
    if (typeof gtag !== 'function' || typeof fbq !== 'function') return;

    const now = new Date().toLocaleString();
    gtag('event', 'inputYear', {
        event_description: '输入了年份',
        page_url: window.location.href,
        year: element.value,
        time: now,
        Remark: {
            page_url: '页面URL',
            year: '年份',
            time: '事件发生时间',
        },
    });

    fbq('trackCustom', 'inputYear', {
        event_description: '输入了年份',
        page_url: window.location.href,
        year: element.value,
        time: now,
        Remark: {
            page_url: '页面URL',
            year: '年份',
            time: '事件发生时间',
        },
    });
};

// 选择拖车追踪
function selectTrailer(brand, trailer) {
    if (typeof gtag !== 'function' || typeof fbq !== 'function') return;

    const now = new Date().toLocaleString();
    gtag('event', 'selectTrailer', {
        event_description: '选择了那个拖车',
        page_url: window.location.href,
        brand: brand,
        trailer: trailer,
        time: now,
        Remark: {
            page_url: '页面URL',
            brand: '品牌',
            trailer: '拖车',
            time: '事件发生时间',
        },
    });

    fbq('trackCustom', 'selectTrailer', {
        event_description: '选择了那个拖车',
        page_url: window.location.href,
        brand: brand,
        trailer: trailer,
        time: now,
        Remark: {
            page_url: '页面URL',
            brand: '品牌',
            trailer: '拖车',
            time: '事件发生时间',
        },
    });
};

// 选择颜色追踪
function selectColor(colorLabel) {
    if (typeof gtag !== 'function' || typeof fbq !== 'function') return;

    const now = new Date().toLocaleString();
    gtag('event', 'selectColor', {
        event_description: '选择了那个颜色',
        page_url: window.location.href,
        color: colorLabel,
        time: now,
        Remark: {
            page_url: '页面URL',
            color: '颜色',
            time: '事件发生时间',
        },
    });

    fbq('trackCustom', 'selectColor', {
        event_description: '选择了那个颜色',
        page_url: window.location.href,
        color: colorLabel,
        time: now,
        Remark: {
            page_url: '页面URL',
            color: '颜色',
            time: '事件发生时间',
        },
    });
};

// 悬浮到了结账按钮
function hoverCheckoutButton() {
    if (typeof gtag !== 'function' || typeof fbq !== 'function') return;

    const now = new Date().toLocaleString();
    gtag('event', 'hoverCheckoutButton', {
        event_description: '悬浮到了结账按钮',
        page_url: window.location.href,
        time: now,
        Remark: {
            page_url: '页面URL',
            time: '事件发生时间',
        },
    });

    fbq('trackCustom', 'hoverCheckoutButton', {
        event_description: '悬浮到了结账按钮',
        page_url: window.location.href,
        time: now,
        Remark: {
            page_url: '页面URL',
            time: '事件发生时间',
        },
    });
};


// 滚动深度追踪（window 版，防 overflow:hidden 爆发）
(function () {
    if (typeof gtag !== 'function' || typeof fbq !== 'function') return;

    var fired = { 25: false, 50: false, 75: false, 100: false };

    function getScrollPercent() {
        var doc = document.documentElement;
        var body = document.body;

        var scrollTop = window.pageYOffset || doc.scrollTop || body.scrollTop || 0;
        var scrollHeight = Math.max(body.scrollHeight, doc.scrollHeight);
        var clientHeight = window.innerHeight || doc.clientHeight;

        var maxScroll = scrollHeight - clientHeight;

        // ⭐ 关键防护：不可滚动页面，直接视为 0%
        if (maxScroll <= 10) return 0;

        return Math.round((scrollTop / maxScroll) * 100);
    }

    function onScroll() {
        var percent = getScrollPercent();
        if (percent <= 0) return;

        var now = new Date().toLocaleString();

        [25, 50, 75, 100].forEach(function (p) {
            var hit = p === 100 ? percent >= 99 : percent >= p;

            if (hit && !fired[p]) {
                fired[p] = true;

                gtag('event', 'scroll_depth_' + p, {
                    scroll_percent: p,
                    event_description: '滚动深度追踪',
                    page_url: location.href,
                    time: now,
                });

                fbq('trackCustom', 'scroll_depth_' + p, {
                    scroll_percent: p,
                    event_description: '滚动深度追踪',
                    page_url: location.href,
                    time: now,
                });
            }
        });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
})();
